<template lang="pug">
ValidationObserver(:disabled='true' slim)
  modal#subimit-envelope-to-review-modal(
    :no-footer='true'
    :title='$t("modal.envelope.submitToReview")'
    ref='modal'
    size='md'
  )
    .col-12.mt-4
      form.form
        .row
          .col-12
            ValidationProvider(
              name='nome do envelope'
              ref='titleProvider'
              rules='required'
              v-slot='{ errors }'
            )
              .form-group
                label.review-label(for='subject') {{ $t('modal.envelope.review.title') }}
                .form-control-icon
                  icon(name='file')
                  input#subject.form-control(
                    :class='{ "border-danger": remainingCaracters.title === 0 }'
                    :placeholder='$t("modal.envelope.review.titlePlaceholder")'
                    autocomplete='off'
                    maxlength='60'
                    type='text'
                    v-model='title'
                  )
                  max-text-counter(
                    :limit='60'
                    :value='title'
                    @remaining='remainingCaracters.title = $event'
                  )
                small.text.text-danger {{ errors[0] }}
    .form-group
      label.text-start.ps-1.mb-2(for='visibility') {{ $t('modal.envelope.editVisibility.selectLabel') }}
      select#visibility.form-control(v-model='selectedVisibility')
        option(
          :key='opt.value'
          :value='opt.value'
          v-for='opt in visibilityOptions'
        ) {{ opt.label }}
    .text-end.mt-4
      button.btn.btn-secondary(@click='close' type='button') {{ $t('button.cancel') }}
      button.btn.btn-primary.ms-2(
        :disabled='!title || !selectedVisibility'
        @click='nextStep'
        type='button'
      ) {{ $t('modal.envelope.submitToReview') }}
</template>
<script>
import Modal from '@/ui/molecules/Modal.vue';
import MaxTextCounter from '@/ui/atoms/MaxTextCounter.vue';
import EnvelopesService from '@/modules/business/services/http/envelopes/EnvelopesService';
import Logger from '@/services/Logger';
import EnvelopeState from '@/enums/EnvelopeState';
import Icon from '@/ui/atoms/Icon.vue';

export default {
  name: 'SubmitEnvelopeToReviewModal',
  props: {
    visibilityOptions: {
      type: Array,
      required: true,
    },
    visibilitySelected: {
      type: String,
      default: null,
    },
    envelope: {
      type: Object,
      default: null,
    },
  },
  components: {
    MaxTextCounter,
    Modal,
    Icon,
  },
  data() {
    return {
      selectedVisibility: this.visibilitySelected,
      title: '',
      submitting: false,
      remainingCaracters: {
        title: 500,
      },
    };
  },
  watch: {
    visibilitySelected(val) {
      this.selectedVisibility = val;
    },
  },
  computed: {
    isWaitingReview() {
      return this.envelope.state === EnvelopeState.WAITING_REVIEW;
    },
    selectWhetherToSaveOrSend() {
      return (
        this.envelope.state !== EnvelopeState.IN_TRANSIT &&
        this.envelope.state !== EnvelopeState.EXPIRED
      );
    },
  },
  methods: {
    open() {
      if (!this.envelope) {
        return;
      }
      this.title = String(this.envelope.title ?? '').split('.', 1)[0];
      this.selectedVisibility = this.visibilitySelected;
      if (this.$refs.modal) {
        this.$refs.modal.open();
      }
    },
    close() {
      if (this.$refs.modal) {
        this.$refs.modal.close();
      }
    },
    async changeVisibility() {
      let visibility = this.selectedVisibility;
      let team = null;
      if (visibility && visibility.startsWith('team:')) {
        team = visibility.replace('team:', '');
        visibility = 'team';
      }
      const payload = { visibility };
      if (team) {
        payload.team = team;
      }
      await EnvelopesService.changeVisibility(this.envelope.id, payload);
    },
    async submitEnvelopeToReview() {
      try {
        if (this.isWaitingReview || !this.selectWhetherToSaveOrSend) {
          return;
        }
        await EnvelopesService.submitToReview(this.envelope.id);
        this.close();
        this.$emit('envelope-submitted-to-review');
      } catch (error) {
        Logger.consoleError('Failed to submit envelope to review', error);
      }
    },
    async nextStep() {
      if (this.submitting || !this.envelope?.id) {
        return;
      }
      this.submitting = true;
      try {
        const { valid } = await this.$refs.titleProvider.validate();
        const validVisibility = this.visibilityOptions.some(
          (option) => option.value === this.selectedVisibility
        );
        if (!valid || !validVisibility) {
          return;
        }
        this.$loading(true);
        await EnvelopesService.update(this.envelope.id, { title: this.title });
        await this.changeVisibility();
        await this.submitEnvelopeToReview();
      } catch (e) {
        Logger.consoleError(
          'Failed to update envelope, its not submitted to review:',
          e
        );
      } finally {
        this.submitting = false;
        this.$loading(false);
      }
    },
  },
};
</script>
